import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpEventType, HttpClient, HttpXhrBackend } from '@angular/common/http';
import * as ngswal from "sweetalert";
import { tap } from 'rxjs/operators';
declare var $;

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
/** Upload component*/
export class UploadComponent implements OnInit {

  public progress: number;
  public message: string;
  @Output() public onUploadFinished = new EventEmitter();

  constructor(private http: HttpClient) {
    this.progress = 0; this.message = '';
  }

  ngOnInit(): void {
    this.progress = 0; this.message = '';
  }

  public uploadFile = (files) => {
    if (files.length === 0) {
      return false;
    }
    let fileToUpload = <File>files[0];
    this.progress = 0; this.message = '';
    let ext = fileToUpload.name.toString().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['zip']) == -1) {
      ngswal("Warning !", "Invalid Package format !", "warning");
      return false;
    }
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('ClientApiUrl', localStorage.UploadApi);
    formData.append('Id', localStorage.aEID);
    formData.append('LoginId', localStorage.aLoginID);
    formData.append('PublisherId', localStorage.aPubID);
    $("#LoadingImagePopup").show();

    let http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
    http.post($('base')[0].href + 'api/Endpoint/PostFileClient', formData).subscribe(
      (response: Response) => {
        let msgInfo = 'Success'; let msgDetails = '';
        let result = $(response.headers);
        $.each(result, function (e, val) {
          if (val.key == 'ErrorMessage') {
            msgInfo = 'Warning';
            msgDetails = val.value.toString();
          }
          else if (val.key == 'SuccessMessage') {
            msgInfo = 'Success';
            msgDetails = val.value.toString();
          }
        });
        $('#divFileUpload').css('display', "none");

        ngswal({
          position: 'top-end',
          type: msgInfo.toLowerCase(),
          title: "<i>" + msgInfo + "</i>",
          text: msgDetails,
          showConfirmButton: false,
          timer: 2000,
          html: true
        });

        $("#LoadingImagePopup").hide();
      },
      (error) => {
        console.log(error.message);    // Show error, if any.
        ngswal("Warning !", error.message, "warning");
        $("#LoadingImagePopup").hide();
      });

    //this.http.post($('base')[0].href + 'api/Endpoint/PostFileClient', formData,
    //  {
    //    reportProgress: true, observe: 'events'
    //  }).subscribe(event => {
    //    switch (event.type) {
    //      case HttpEventType.UploadProgress:
    //        $("#LoadingImagePopup").show();
    //        //this.progress = Math.round((100 * event.loaded) / event.total);
    //        break;
    //      case HttpEventType.Response:
    //        if (event.statusText == "OK") {
    //          $('#btnLoadList').trigger('click');
    //          //Final Response after upload complete.
    //          this.message = 'Upload success.';
    //          $('#divFileUpload').css('display', "none");
    //          ngswal({
    //            position: 'top-end',
    //            type: "success",
    //            title: "Uploaded !",
    //            text: 'Upload success.!',
    //            showConfirmButton: false,
    //            timer: 1500
    //          });
    //        }
    //        else
    //          this.message = 'Error occure upload process.';
    //        this.onUploadFinished.emit(event.body);
    //        $("#LoadingImagePopup").hide();
    //      default:
    //        $("#LoadingImagePopup").hide();
    //        break;
    //    }
    //  });
    return true;
  }

  CallHideModal() {
    if ($('#btnModalHide').length > 0) {
      $('#btnModalHide').trigger('click');
    }
  }
}
